import localeNl from '@angular/common/locales/nl';

/**
 * Angular 22's Dutch locale data formats dates differently than Angular 12's did:
 *   Angular 12: "12 feb. 2024 10:21:50"      Angular 22: "12 feb 2024, 10:21:50"
 * Same Dutch locale, with the Angular 12 month abbreviations (with a dot) and date-time joining, so every date in the
 * lists and details reads as before.
 */
const ABBREVIATED_MONTHS = ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];

const MONTHS_FORMAT = 5;
const MONTHS_STANDALONE = 6;
const DATE_TIME_FORMAT = 12;

const withAbbreviatedMonths = (months: any[]): any[] => [months[0], ABBREVIATED_MONTHS, months[2]];

export const localeNlAngular12: any[] = [...localeNl];
localeNlAngular12[MONTHS_FORMAT] = withAbbreviatedMonths(localeNl[MONTHS_FORMAT] as any[]);

// Angular stores the standalone months as undefined when they equal the format months
if (localeNl[MONTHS_STANDALONE]) {
    localeNlAngular12[MONTHS_STANDALONE] = withAbbreviatedMonths(localeNl[MONTHS_STANDALONE] as any[]);
}
// empty slots (undefined) mean "same as the first format"
localeNlAngular12[DATE_TIME_FORMAT] = ['{1} {0}', undefined, "{1} 'om' {0}", undefined];
